import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=54b59d8c&scoped=true"
import script from "./Transactions.vue?vue&type=script&lang=js"
export * from "./Transactions.vue?vue&type=script&lang=js"
import style0 from "./Transactions.vue?vue&type=style&index=0&id=54b59d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b59d8c",
  null
  
)

export default component.exports